import { useEffect, useState } from "react";
import { apiFetch, ApiError, NetworkError } from '@/discord/services/api';
import {DowntimeEntry, StaffInServiceList} from '@/discord/types/status';
import { useNavigate } from "react-router-dom";

export function useStatus() {
    const [isOperational, setIsOperational] = useState<boolean>(false);
    const [statusDowntime, setStatusDowntime] = useState<DowntimeEntry[]>([]);
    const [staffInServiceList, setStaffInServiceList] = useState<StaffInServiceList | null>(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        apiFetch<{ operational: boolean }>("/status/operational")
            .then(data => {
                setIsOperational(data.operational);
                apiFetch<DowntimeEntry[]>("/status/downtime")
                    .then(data => {
                        setStatusDowntime(data);
                    })
                    .catch((error) => {
                        if ((error instanceof ApiError && error.status === 500) || error instanceof NetworkError) {
                            navigate("/internal-server-error", { replace: true });
                        } else {
                            setStatusDowntime([]);
                        }
                    });
                apiFetch<StaffInServiceList>("/status/staff")
                    .then(data => {
                        setStaffInServiceList(data);
                    })
                    .catch((error) => {
                        if ((error instanceof ApiError && error.status === 500) || error instanceof NetworkError) {
                            navigate("/internal-server-error", { replace: true });
                        } else {
                            setStaffInServiceList(null);
                        }
                    })
                    .finally(() => setLoading(false));
            })
            .catch((error) => {
                if ((error instanceof ApiError && error.status === 500) || error instanceof NetworkError) {
                    navigate("/internal-server-error", { replace: true });
                }
                setLoading(false);
            })
    }, [navigate]);

    return { isOperational, statusDowntime, staffInServiceList, loading };
}